import { z } from "zod";

import {
  INVESTMENT_OBJECTIVE_VALUES,
  INVESTMENT_TIME_HORIZON_VALUES,
  RISK_TOLERANCE_VALUES,
} from "~/v2/api/rest/account";
import { INVESTMENT_EXPERIENCE_VALUES } from "../../constant";

export const zInvestmentExperience = z.object({
  investment_experience_with_options: z.enum(INVESTMENT_EXPERIENCE_VALUES),
  investment_experience_with_stocks: z.enum(INVESTMENT_EXPERIENCE_VALUES),
  investment_objective: z.enum(INVESTMENT_OBJECTIVE_VALUES),
  investment_time_horizon: z.enum(INVESTMENT_TIME_HORIZON_VALUES),
  risk_tolerance: z.enum(RISK_TOLERANCE_VALUES),
});

export type InvestmentExperience = z.infer<typeof zInvestmentExperience>;
